import { MenuItem } from './types';
import { accountManagement } from './sections/account-management';
import {
  fleetcorSection,
  exorigoUposSection,
  driverAccountManagementSection,
  orderLookupSection,
  deeplinkManagementSection,
} from './sections/individual-partners';
import { bmwSection } from './sections/bmw';
import { voucherCampaignsSection } from './sections/voucher-campaigns';
import { customerSupportSection } from './sections/customer-support';
import { marketingSection } from './sections/ryd-marketing';
import { rydFinancialSection } from './sections/ryd-financial';
import { backofficeSection } from './sections/backoffice';
import { developerHubSection } from './sections/internal-developer-hub';
import { fleetManagementSection } from './sections/fleet-management';
import { partnerAdministrationSection } from './sections/partner-administration';
import { rydFleetOperationsSection } from './sections/ryd-fleet-operations';
import { troubleshootingSection } from './sections/troubleshooting';
import { integrationGuideSection } from './sections/integration-guide';
import { insightsAnalyticsSection } from './sections/insights-analytics';
import { webhookManagementSection } from './sections/webhook-management';
import { aiAtRydSection } from './sections/ai-at-ryd';
import { userManagementSection } from './sections/user-management';
import { platformStatusSection } from './sections/platform-status';
import { integrationSettingsSection } from './sections/integration-and-settings';
import { supportFeedbackSection, portalInformationSection } from './sections/settings-and-support';
import { payOperationsSection } from './sections/ryd-pay-operations';
import { securityAndComplianceSection } from './sections/security-and-compliance';

export type { MenuItem } from './types';

// Rendered pinned at the top of every sidebar variant, outside the section grouping.
export const homeMenuItem: MenuItem = {
  title: 'Home',
  icon: 'stroke-home',
  iconf: 'fill-home',
  type: 'link',
  path: '/',
};

export const menuItems: { data: MenuItem[] } = {
  data: [
    homeMenuItem,
    ...fleetcorSection,
    ...exorigoUposSection,
    ...driverAccountManagementSection,
    ...orderLookupSection,
    ...rydFleetOperationsSection,
    ...customerSupportSection,
    ...payOperationsSection,
    ...marketingSection,
    ...rydFinancialSection,
    ...backofficeSection,
    ...developerHubSection,
    ...fleetManagementSection,
    ...accountManagement,
    ...troubleshootingSection,
    ...integrationGuideSection,
    // BMW owns a dedicated, access-gated section heading. Keeping it near the
    // integration guide preserves the sidebar's information architecture
    // without visually nesting BMW under a generic or unrelated section.
    ...bmwSection,
    ...voucherCampaignsSection,
    ...deeplinkManagementSection,
    ...insightsAnalyticsSection,
    ...webhookManagementSection,
    ...aiAtRydSection,
    ...userManagementSection,
    ...partnerAdministrationSection,
    ...integrationSettingsSection,
    ...securityAndComplianceSection,
    ...supportFeedbackSection,
    ...platformStatusSection,
    ...portalInformationSection,
  ],
};
